// monthsData.js
// Utility for consistent month data across the application

/**
 * Array of month data objects with index, value, short name, and full name
 */
export const months = [
  { index: 1, value: 'jan', short: 'Jan', full: 'Januari' },
  { index: 2, value: 'feb', short: 'Feb', full: 'Februari' },
  { index: 3, value: 'mar', short: 'Mar', full: 'Maret' },
  { index: 4, value: 'apr', short: 'Apr', full: 'April' },
  { index: 5, value: 'mei', short: 'Mei', full: 'Mei' },
  { index: 6, value: 'jun', short: 'Jun', full: 'Juni' },
  { index: 7, value: 'jul', short: 'Jul', full: 'Juli' },
  { index: 8, value: 'agu', short: 'Agu', full: 'Agustus' },
  { index: 9, value: 'sep', short: 'Sep', full: 'September' },
  { index: 10, value: 'okt', short: 'Okt', full: 'Oktober' },
  { index: 11, value: 'nov', short: 'Nov', full: 'November' },
  { index: 12, value: 'des', short: 'Des', full: 'Desember' },
];

/**
 * Get month data by index
 * @param {Number} index - Month index (1-12)
 * @returns {Object|null} Month data object or null if not found
 */
export function getMonthByIndex(index) {
  return months.find(month => month.index === index) || null;
}

/**
 * Get month data by value
 * @param {String} value - Month value (e.g., 'jan', 'feb')
 * @returns {Object|null} Month data object or null if not found
 */
export function getMonthByValue(value) {
  return months.find(month => month.value === value.toLowerCase()) || null;
}

export function filterMonths(index) {
  return months.filter(month => month.index <= index);
}

/**
 * Get current month data
 * @returns {Object} Current month data object
 */
export function getCurrentMonth() {
  const currentMonthIndex = new Date().getMonth() + 1; // JavaScript months are 0-indexed
  return getMonthByIndex(currentMonthIndex);
}
